import classNames from 'classnames'
import React from 'react'

import { Operator, type OperatorProps } from '~/components/elements/Operator'

import styles from './OperatorContainer.css'

export type OperatorContainerProps = React.PropsWithChildren<{
  'data-testid'?: string
  operator: OperatorProps['operator'] | null
  size: OperatorProps['size']
}>

export const OperatorContainer = ({
  children,
  'data-testid': dataTestId = 'components-elements-operator-container',
  operator,
  size,
}: OperatorContainerProps) => (
  <div
    className={classNames(styles.root, styles[`size-${size}`])}
    data-testid={dataTestId}
  >
    {operator && (
      <Operator className={styles.operator} operator={operator} size={size} />
    )}

    {children}
  </div>
)
